import React, { useEffect } from 'react';
import ComingSoon from 'components/ComingSoon/ComingSoon';
import TopBar from 'components/TopBar/TopBar';
import { Wrapper } from './styled';
import Copyright from 'components/Copyright/Copyright';

const Careers = () => {
	useEffect(() => {
		document.title = 'Careers | Flass';
	});
	return (
		<Wrapper>
			<TopBar />
			<ComingSoon />
			<Copyright style={{ position: 'absolute', bottom: 0 }} />
		</Wrapper>
	);
};

export default Careers;
